/**
 * A country's flag, as a rectangle, for any country there is.
 *
 * WHY NOT THE EMOJI. A flag emoji is a CHARACTER, so its shape belongs to the
 * system font: Apple draws them waving, Windows draws nothing at all and
 * falls back to the two letters. Neither is ours to choose, and a waving flag
 * beside a client's name reads as a different kind of object from every other
 * mark on the page.
 *
 * WHY NOT `FlagIcon`, which is vendored and therefore better. It carries the
 * seventeen countries `DIAL_CODES` lists, because that is all a phone picker
 * can offer. A citizenship is any of about two hundred, and a client from
 * Morocco would get nothing — so this is the wider of the two, and the one
 * the security-exclusions dropdown has been using.
 *
 * ACCEPTS WHATEVER THE RECORD STORES. `clients.country_of_citizenship` holds
 * alpha-3 ("CAN"), the wizard holds alpha-2, and a geocoder hands back a
 * name; `countryCode` resolves all three. Anything it cannot place renders
 * nothing rather than a broken image.
 */
import { useState } from 'react';

import { countryCode, countryName } from '@/shared/geo';

export function CountryFlag({
  code,
  className = 'h-4 w-6 shrink-0 object-cover',
}: {
  /** An alpha-2, an alpha-3, or a country name. */
  code: string;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const iso = countryCode(code);
  if (failed || !iso) return null;
  return (
    <img
      src={`https://flagcdn.com/${iso.toLowerCase()}.svg`}
      // DECORATIVE, with the country on `title` for a pointer and in the
      // label of whatever draws it for a reader. A flag announced as "flag"
      // tells somebody nothing they can use.
      alt=""
      aria-hidden
      title={countryName(iso)}
      /* A LIST OF TWO HUNDRED COUNTRIES OPENS TWO HUNDRED REQUESTS otherwise.
        The phone picker carries seventeen and could afford to be eager; a
        citizenship menu is the whole world, and only the dozen rows in view
        are worth fetching. Harmless everywhere else: a flag already on screen
        loads exactly as before. */
      loading="lazy"
      className={className}
      // A country the CDN has no file for leaves the row alone rather than
      // rendering a broken-image glyph.
      onError={() => setFailed(true)}
    />
  );
}
